<template>
  <div>
    <el-row v-if="query.moment_id != ''">
      <el-col :span="24">
        <el-button
          style=" padding:0; margin:20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
          </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-input class="search-el" size="small" v-model="query.nickname" placeholder="用户昵称"></el-input>
      <el-input class="search-el" size="small" v-model="query.content" placeholder="内容"></el-input>
      <el-select class="search-el" size="small" v-model="query.report" placeholder="举报状态">
        <el-option label="全部动态" value="all"></el-option>
        <el-option label="被举报" value="report"></el-option>
      </el-select>
      <el-date-picker class="search-el" size="small" v-model="query.date_timestamp" value-format='yyyy-MM-dd HH:mm:ss' type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
      </el-date-picker>
      <el-button type="primary" size="small" @click="getList()">
        查询
      </el-button>
    </el-row>
    <el-row>
      <el-table v-loading="loading" :data="list" border size="mini" :stripe="true" style="width: 100%; margin: 20px 0">
        <el-table-column label="头像" align="center">
          <template slot-scope="{row}">
            <img :src="row.avatar" style="width:40px" alt="">
          </template>
        </el-table-column>
        <el-table-column label="昵称" align="center">
          <template slot-scope="{row}">
            <div>{{ row.nickname }}</div>
            <div>{{ row.mobile_phone }}</div>
          </template>
        </el-table-column>
        <el-table-column label="内容" align="center">
          <template slot-scope="{row}">
            {{ row.original == null ? row.content : row.original }}
          </template>
        </el-table-column>
        <el-table-column prop="likes" label="点赞" align="center"></el-table-column>
        <el-table-column prop="created_at" label="发布时间" align="center" width="90"></el-table-column>
        <el-table-column label="显示状态" align="center">
          <template slot-scope="{row}">
            <div>
              <span v-if="row.show == 1" style="color:#67C23A"><i class='el-icon-circle-check'></i> 显示</span>
              <span v-else  style="color:#909399"><i class='el-icon-circle-close'></i> 隐藏</span>
              <el-button type="text" size="small" style="margin-left:5px" @click="onlineOffline(row.reply_id)">
                {{ row.show == 1 ? '隐藏' : '显示'}}
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{row}">
            <template v-if="row.report_content != null">
              <el-popover
                placement="left"
                title="举报信息"
                width="800"
                trigger="click"
                style="margin-right:10px">
                <el-row>
                  <el-table :data="row.report_list" border size="mini" :stripe="true" style="width: 100%; margin: 20px 0">
                    <el-table-column label="举报人头像" align="center">
                      <template slot-scope="{row}">
                        <img :src="row.avatar" style="width:40px;height:40px;" alt="">
                      </template>
                    </el-table-column>
                    <el-table-column label="举报人昵称" align="center">
                      <template slot-scope="{row}">
                        {{row.nickname}}
                      </template>
                    </el-table-column>
                    <el-table-column label="举报人手机" align="center">
                      <template slot-scope="{row}">
                        {{row.mobile_phone}}
                      </template>
                    </el-table-column>
                    <el-table-column label="举报时间" align="center">
                      <template slot-scope="{row}">
                        {{row.created_at}}
                      </template>
                    </el-table-column>
                    <el-table-column label="举报类型" align="center">
                      <template slot-scope="{row}">
                        {{row.report_type}}
                      </template>
                    </el-table-column>
                    <el-table-column label="举报详情" align="center">
                      <template slot-scope="{row}">
                        {{row.report_content}}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
                <el-button size="small" slot="reference">举报信息</el-button>
              </el-popover>
            </template>
            <el-button type="danger" size="small" @click="deleteRow(row.reply_id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination background @current-change="getList" :current-page.sync="query.page" :page-size="query.limit" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  getMomentReplies,
  deleteReplies,
  onlineOfflineReply
} from "@/api/moment";

export default {
  data: function() {
    return {
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        report: "",
        nickname: "",
        content: "",
      },
      pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
    };
  },
  created: function() {
    this.query.moment_id = this.$route.query.id == undefined ? '' : this.$route.query.id
    this.getList();
  },
  methods: {
    deleteRow(id) {
      this.$confirm("此操作将删除该评论, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteReplies({
          reply_id: id
        }).then(response => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success"
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        });
      });
    },
    choiceHandle(id) {
      addChoice({
        moment_id: id
      }).then(response => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "操作成功",
            type: "success"
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          });
        }
      });
    },
    onlineOffline(id) {
      onlineOfflineReply({
        reply_id: id
      }).then(response => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "操作成功",
            type: "success"
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          });
        }
      });
    },
    ref() {
      window.history.go(0);
    },
    getList() {
      this.loading = true;
      getMomentReplies(this.query).then(response => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    }
  }
};
</script>
